export const TRUSTED_ROOT_DOMAIN = 'bj33smarter.com';

const ROOT_DOMAIN = `.${TRUSTED_ROOT_DOMAIN}`;
const STAGING_ROOT_DOMAIN = `staging.${TRUSTED_ROOT_DOMAIN}`;
const STAGING_DOMAIN = `.${STAGING_ROOT_DOMAIN}`;

export function isTrustedHostname(hostname: string) {
  return (
    hostname === TRUSTED_ROOT_DOMAIN ||
    hostname.endsWith(`.${TRUSTED_ROOT_DOMAIN}`)
  );
}

export function isBj33SmarterDomain() {
  return isTrustedHostname(window.location.hostname);
}

// staging 树的登录态 cookie 限定在 .staging 子域内：正式站与测试站不再共用
// .bj33smarter.com 同名 cookie，避免两边环境登录互相覆盖造成互相顶号
function isStagingHost() {
  const { hostname } = window.location;
  return hostname === STAGING_ROOT_DOMAIN || hostname.endsWith(STAGING_DOMAIN);
}

function cookieDomain() {
  return isStagingHost() ? STAGING_DOMAIN : ROOT_DOMAIN;
}

export function cookieAttributes() {
  const a = ['Path=/'];
  // 持久化登录态 cookie（token/subject/user_store 均经 setDomainCookie 写入），
  // 有效期对齐 SasanServer 的 JWT_EXPIRES_IN（默认 7d）。此前不带 Max-Age 是会话
  // cookie，浏览器重启即丢而 JWT 仍有效，agent 端只能从父域 cookie 读 token，
  // 会出现「token 有效却被判未登录」被踢回登录页（2026-10-28 排查结论）。
  // 若后端调整 JWT_EXPIRES_IN，此处需同步。
  a.push('Max-Age=604800');
  if (isBj33SmarterDomain()) a.push(`Domain=${cookieDomain()}`);
  if (window.location.protocol === 'https:') {
    a.push('Secure', 'SameSite=None');
  } else {
    a.push('SameSite=Lax');
  }
  return a.join('; ');
}

// staging 只读写 .staging 子树内的 cookie，绝不写/清 .bj33smarter.com：
// 根域 cookie 是正式站登录态与 agent 正式站读 token 的活通道，staging 一旦
// 驱逐或覆盖它，正式站（尤其 agent 正式站这类只读 cookie 的消费方）立即掉登录
export function setDomainCookie(name: string, value: string) {
  document.cookie = `${name}=${encodeURIComponent(value)}; ${cookieAttributes()}`;
  if (isStagingHost()) {
    // 同时写一组带前缀的别名 cookie，供 agent staging 构建按名精确读取：
    // 其 document.cookie 里根域正式 token 与 .staging 测试 token 同名，取值有歧义
    document.cookie = `staging_${name}=${encodeURIComponent(value)}; ${cookieAttributes()}`;
  }
}

export function removeDomainCookie(name: string) {
  const expire = 'Expires=Thu, 01 Jan 1970 00:00:00 GMT';
  document.cookie = `${name}=; ${expire}; Path=/`;
  if (isBj33SmarterDomain()) {
    document.cookie = `${name}=; ${expire}; Path=/; Domain=${cookieDomain()}`;
  }
  if (isStagingHost()) {
    document.cookie = `staging_${name}=; ${expire}; Path=/`;
    document.cookie = `staging_${name}=; ${expire}; Path=/; Domain=${STAGING_DOMAIN}`;
  }
}

export function readCookie(name: string): string | null {
  const m = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]+)`));
  return m ? decodeURIComponent(m[1]) : null;
}
